import React from 'react';
import PropTypes from 'prop-types';

import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';
import { ButtonLinkWidget } from '@glowforge/gf-styled/contentful-widgets';

import Testimonials from './testimonials';

const TestimonialsWidget = ({ sections, minHeightMobile }) => {
  // Sections is an array, so let's grab the first carousel.
  const { delay, content, title } = sections.find(
    (section) => section.sys?.contentType?.sys?.id === 'carousel'
  )?.fields;

  const testimonials = content?.map(({ fields }) => {
    // We want to coerce the data once server side, instead of every iteration of client-side map.
    const { id, title: testimonialTitle, bodyContent, image, isQuote } = fields;

    const background = fields?.background?.fields;
    const backgroundImage = background?.desktopImage?.fields?.file?.url;
    const colorFields = background?.desktopColor?.fields;
    const backgroundColor = colorFields
      ? `${colorFields?.hue}.${colorFields?.tint}`
      : 'magic.base';

    const button = fields?.button ? (
      <ButtonLinkWidget model={fields?.button} />
    ) : null;

    return {
      id,
      title: testimonialTitle,
      bodyContent,
      image,
      backgroundImage,
      backgroundColor,
      button,
      isQuote,
    };
  });

  return (
    <Testimonials
      title={title}
      delay={delay}
      testimonials={testimonials}
      minHeightMobile={minHeightMobile}
    />
  );
};

TestimonialsWidget.propTypes = {
  ...widgetPropType,
  minHeightMobile: PropTypes.string,
};
TestimonialsWidget.defaultProps = {
  ...widgetDefaultProps,
  minHeightMobile: '250px',
};

export default TestimonialsWidget;
